export type AuthSessionIdentifiers = {
  clientId: number | string | null;
  sessionId: number | string | null;
};

export function getAuthSessionIdentifiers(authSession: unknown): AuthSessionIdentifiers {
  const sessionData =
    (authSession as { session_data?: unknown } | null)?.session_data || authSession;
  const nestedSessionData =
    (sessionData as { session_data?: unknown } | null)?.session_data || null;

  return {
    clientId:
      (
        sessionData as {
          client?: { id?: number | string | null };
          client_id?: number | string | null;
        } | null
      )?.client?.id ??
      (
        nestedSessionData as {
          client?: { id?: number | string | null };
          client_id?: number | string | null;
        } | null
      )?.client?.id ??
      (sessionData as { client_id?: number | string | null } | null)?.client_id ??
      (nestedSessionData as { client_id?: number | string | null } | null)?.client_id ??
      (authSession as { client?: { id?: number | string | null } } | null)?.client?.id ??
      null,
    sessionId:
      (sessionData as { session_id?: number | string | null; id?: number | string | null } | null)
        ?.session_id ??
      (
        nestedSessionData as {
          session_id?: number | string | null;
          id?: number | string | null;
        } | null
      )?.session_id ??
      (sessionData as { id?: number | string | null } | null)?.id ??
      (nestedSessionData as { id?: number | string | null } | null)?.id ??
      null,
  };
}

export const RETAIL_SESSION_EXPIRED_EVENT = "protego:retail-session-expired";
const OTP_TOKEN_STORAGE_KEY = "otp_access_token";

export const clearOtpTokenStorage = () => {
  if (typeof window === "undefined") return;

  localStorage.removeItem(OTP_TOKEN_STORAGE_KEY);
};

export const clearRetailSessionStorage = () => {
  clearOtpTokenStorage();
  if (typeof window === "undefined") return;
  localStorage.removeItem("resumeSessionData");
};

export const dispatchRetailSessionExpired = () => {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(RETAIL_SESSION_EXPIRED_EVENT));
};
